import React, { useState } from 'react'
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import { MuiInput } from '../../components/basicComponent/MuiInput';
import {
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Box,
  } from "@mui/material";

  
const PNRRemarksReport = () => {
    const [value, setValue] = useState("asc");
    
      const handleChange = (event: {
        target: { value: React.SetStateAction<string> };
      }) => {
        setValue(event.target.value);
      };
      
  return (
    <div className="grow">
    <SideMenu />
    <div className="wrapper flex grow flex-col">
      <Header />
      <main className="grow content" id="content" role="content">
        <div className="container-fixed">
          <div className="card-header text-center">
            <h3 className="card-title">PNR Remarks Report</h3>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-custom">
                <div className="card-body">
                  <div className="row mt-4">
                  <div className="col-md-4">
                     <MuiInput label={"SPNR"} placeholder='SPNR'/>
                    </div>
                    <div className="col-md-4">
                      <MuiDatePicker
                        label="From Date     "
                        value={null}
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiDatePicker
                        label="Agency Name "
                        value={null}
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                      />
                    </div>

                    <div className="col-md-4  mt-3">
                        <Box
                          border={1}
                          borderColor="grey.300"
                          borderRadius={1}
                          px={2}
                          width="fit-content"
                        >
                          <FormControl component="fieldset">
                            <FormLabel
                              component="legend"
                              sx={{ color: "orange", fontWeight: "bold", marginBottom:"-4px" }}
                            >
                            Date wise
                            </FormLabel>
                            <RadioGroup
                              row
                              value={value}
                              onChange={handleChange}
                              aria-label="order"
                              name="order-radio-buttons-group"
                            >
                              <FormControlLabel
                                value=" Booked Date"
                                control={<Radio />}
                                label=" Booked Date"
                              />
                              <FormControlLabel
                                value="Reminder Date"
                                control={<Radio />}
                                label="Reminder Date"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </div>
               
                    

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton
                          className="clear-btn "
                          label="Clear"
                          type="submit"
                        />
                        <MuiButton
                          label={"Get"}
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  )
}

export default PNRRemarksReport
